/**
 * IMPORTS
 */

import { useState } from "react";

import * as Dialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";

// components
import { SpinnerSimple } from "@components/spinner-simple/spinner-simple";

// typings
import { TutorialVideoModalProps } from "./interface";

export function TutorialVideoModal({
  open,
  onClose,
  videoUrl,
  videoNome,
  isLoading,
  isError,
}: TutorialVideoModalProps) {
  const [playbackError, setPlaybackError] = useState(false);

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      setPlaybackError(false);
      onClose();
    }
  };

  const showError = isError || playbackError;

  return (
    <Dialog.Root open={open} onOpenChange={handleOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm" />

        <Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-[min(90vw,900px)] -translate-x-1/2 -translate-y-1/2 rounded-xl bg-white p-6 shadow-xl">
          <div className="mb-4 flex items-center justify-between">
            <Dialog.Title className="text-lg font-semibold text-zinc-900">
              Tutorial de Solicitação
            </Dialog.Title>

            <Dialog.Close
              className="rounded-md p-1 text-zinc-500 transition-colors hover:bg-zinc-100 hover:text-zinc-800"
              aria-label="Fechar"
            >
              <X className="h-5 w-5" />
            </Dialog.Close>
          </div>

          <Dialog.Description className="sr-only">
            Vídeo tutorial para solicitação de remessa
          </Dialog.Description>

          <div className="min-h-[240px]">
            {isLoading && (
              <div className="flex min-h-[240px] items-center justify-center">
                <SpinnerSimple />
              </div>
            )}

            {!isLoading && showError && (
              <div className="flex min-h-[240px] flex-col items-center justify-center gap-2 text-center text-sm text-zinc-600">
                <p>Não foi possível carregar o tutorial.</p>
                <p className="text-zinc-500">
                  Feche este modal e tente novamente. Se o problema persistir, entre em contato com
                  o suporte.
                </p>
              </div>
            )}

            {!isLoading && !showError && videoUrl && (
              <video
                key={videoUrl}
                src={videoUrl}
                controls
                className="w-full rounded-lg bg-black"
                title={videoNome ?? "Tutorial de Solicitação"}
                onError={() => setPlaybackError(true)}
              >
                <track kind="captions" />
              </video>
            )}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
